import React, { ProgressHTMLAttributes } from 'react';
import { cn } from '../../helpers';
import styles from './progress.module.scss';

export type ProgressProps = ProgressHTMLAttributes<HTMLProgressElement>;

/**
 * Progress
 * use progress to indicate a quantative status
 * @param param0
 * @returns
 */
export const Progress = ({ className, max = 100, value, ...props }: ProgressProps): JSX.Element => {
    return (
        <progress
            className={cn(styles.progress, className)}
            max={max}
            value={value}
            {...props}
        >{`${value} %`}</progress>
    );
};
